import {
    NinchatActionType,
    NinchatUpdateTagAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const updateTag = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatUpdateTagAction}`,
    async (arg: NinchatActionParams<NinchatUpdateTagAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatUpdateTagAction

        try {
            return await ninchatClient.send(params)
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
